import MenuButton from '../../Shared/MenuButton';
import {useContext} from 'react';
import {useNavigate} from 'react-router-dom';
import SocketContext from '../../../contexts/SocketContext';
import {AccueilContext} from '../../../contexts/AccueilContext';
import {GameContext} from '../../../contexts/GameContext';
import {useTranslation} from '../../../contexts/LanguageContext';
import {getRandomPseudo} from '../../../utils/randomPseudo';

const CreateGameButton = () => {
    const background = 'url(/images/buttons/menuButton1.png)';
    const backgroundDisabled = 'url(/images/buttons/menuButton1_disabled.png)';
    const backgroundHover = 'url(/images/buttons/menuButton1_hover.png)';

    const accueilContext = useContext(AccueilContext);
    const socketContext = useContext(SocketContext);
    const gameContext = useContext(GameContext);
    const navigate = useNavigate();
    const { language, t } = useTranslation();

    const handleCreateGame = async () => {
        const name = accueilContext.playerName.trim() || getRandomPseudo(language);
        const result = await socketContext.getClient().CreateGame(name);
        if (result.success) {
            gameContext.setGameId(result.value.gameId);
            navigate(`/game/${result.value.gameId}`);
        }
    };

    return (
        <MenuButton
            onClick={handleCreateGame}
            text={t('createGame')}
            buttonWidth={{ xs: '100%', md: '60%' }}
            textSize="h5"
            background={background}
            hoverBackground={backgroundHover}
            dynamicCursor={true}
            staticCursorImage={''}
            disabled={false}
        />
    );
};

export default CreateGameButton;
